import { render, staticRenderFns } from "./ReporteInventario.vue?vue&type=template&id=332dd0e6"
import script from "./ReporteInventario.vue?vue&type=script&lang=js"
export * from "./ReporteInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports